import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { BASE_URL, GET_ALL_CARS } from "../../constant-value";
import api from "../../services/axiosConfig";
import { updateCarKilometer } from "./car-kilometer-slice";


export const getAllCars = createAsyncThunk("carList/getAllCars", async () => {
  try {
      const response = await api.get(`${GET_ALL_CARS}`);
      // const response = await axios.get(`${BASE_URL}${GET_ALL_CARS}`);
    return response.data.cars;
  } catch (error) {
    console.error(error);
  }
});

const defaultValue = [];

const carSlice = createSlice({
  name: "carList",
  initialState: {
    cars: defaultValue,
    isLoading: false,
    hasError: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAllCars.pending, (state, action) => {
        state.isLoading = true;
        state.hasError = false;
      })
      .addCase(getAllCars.fulfilled, (state, action) => {
        state.cars = action.payload;
        state.isLoading = false;
        state.hasError = false;
      })
      .addCase(getAllCars.rejected, (state, action) => {
        state.isLoading = false;
        state.hasError = true;
      })
      // ⚡ واکنش به بروزرسانی کیلومتر در slice دیگر
      .addCase(updateCarKilometer.fulfilled, (state, action) => {
        const { id, kilometer } = action.payload;
        const index = state.cars.findIndex((c) => c.id === id);
        if (index !== -1) {
          state.cars[index].kilometer = kilometer;
        }
      });
  },
});

// Selectors
export const selectCars = (state) => state.carList.cars;
export const selectLoadingState = (state) => state.carList.isLoading;
export const selectErrorState = (state) => state.carList.hasError;

export default carSlice.reducer;

export const { getCars, newCar, editCar, deleteCar } = carSlice.actions;
